"use client";

import { useEffect } from "react";

import { identifyUser, resetIdentity } from "@/lib/analytics/posthog";
import { useInternalAuth } from "@/providers/auth-provider";

/**
 * Liga os eventos do PostHog à conta da pessoa.
 *
 * Fica aqui, e não no cadastro, porque a resposta de `/auth/sign-up` não traz o
 * id do usuário — ele só aparece quando a sessão carrega. Assim vale para quem
 * acabou de se cadastrar e para quem já voltou logado.
 */
export function PostHogIdentify() {
  const { user, isSignedIn } = useInternalAuth();

  useEffect(() => {
    if (!isSignedIn || !user?.id) {
      resetIdentity();
      return;
    }

    identifyUser(user.id, {
      email: user.email ?? undefined,
    });
  }, [isSignedIn, user?.id, user?.email]);

  return null;
}
